import React from 'react';
import Alert from '@mui/material/Alert';

export default function RouteMachineAlerts({
  isBlockedByRisk = false,
  hasActiveSM = false,
  hasRouterError = false,
  hasNoRouteInRegion = false,
  blockedPoints = [],
  blockedText = '',
  isBlockedByWaitingIssuing = false,
}) {
  return (
    <>
      {isBlockedByRisk && (
        <Alert
          severity="warning"
          style={{
            margin: '0.5rem 1rem 1rem',
            fontSize: '0.9rem',
            lineHeight: '1.4',
            whiteSpace: 'normal',
          }}
        >
          O status do <strong>gerenciador de risco</strong> não permite edição da rota. A análise já foi iniciada, por favor, <strong>aguarde</strong>.
        </Alert>
      )}

      {hasActiveSM && (
        <Alert
          severity="warning"
          style={{
            margin: '0.5rem 1rem 1rem',
            fontSize: '0.9rem',
            lineHeight: '1.4',
            whiteSpace: 'normal',
          }}
        >
          <b>Atenção:</b> Ao alterar o(s) endereço(s) durante uma SM ativa ou pré-SM, você poderá invalidar ou atrasar o processo de monitoramento.
        </Alert>
      )}

      {hasRouterError && !hasNoRouteInRegion && (
        <Alert
          severity="error"
          style={{
            margin: '0.5rem 1rem 1rem',
            fontSize: '0.9rem',
            lineHeight: '1.4',
            whiteSpace: 'normal',
          }}
        >
          <b>Não foi possível calcular a rota</b>
          <br />
          Um dos endereços informados não pôde ser usado para gerar o trajeto, pois o ponto está localizado em uma área sem acesso viário (como terrenos, pátios ou áreas industriais).
          <br />
          Para continuar, ajuste o <b>endereço selecionado e o ponto no mapa</b>, posicionando-o sobre uma rua.
        </Alert>
      )}

      {blockedPoints.length > 0 && !isBlockedByWaitingIssuing && (
        <Alert
          severity="warning"
          style={{
            margin: '0.5rem 1rem 1rem',
            fontSize: '0.9rem',
            lineHeight: '1.4',
            whiteSpace: 'normal',
          }}
        >
          <b>Atenção:</b> Não é possível editar <strong>{blockedText}</strong>. Esses pontos estão bloqueados pois já foram informados como <strong>Chegada</strong> ou <strong>Efetivados</strong>.
        </Alert>
      )}
    </>
  );
}
